import { render, staticRenderFns } from "./MenuModifiersHub.vue?vue&type=template&id=57388d04"
import script from "./MenuModifiersHub.vue?vue&type=script&lang=js"
export * from "./MenuModifiersHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports